export enum VirtualRedTagTrailerGraphicState {
    default = 'default',
    blocked = 'blocked',
    success = 'success',
    redTagged = 'redTagged',
}
